export const isValidDate = (dateString: string) =>
  !Number.isNaN(new Date(dateString).getTime());
